class AnalyticsService {

    errorWhenFetchingExternalData(url, error, message) {
        console.log("error "+message+" when fetching data from "+url, error);
    }

    dataError(message, objects) {
        console.log(message, objects);
    }

    timeBooked(url, bookingObject) {
        console.log("booking: "+url, bookingObject);
    }

    bookingCancelled(url, deleteToken) {
        console.log("booking cancelled: "+url, deleteToken);
    }

}

export {AnalyticsService as default}



// WEBPACK FOOTER //
// ../utils/analytics.js